<template>
  <b-card style="padding:40px;">
    <h5 v-if="form.category === 1"><b>AMEND CHANGES REVIEW (STOCKOUT)</b></h5>
    <h5 v-if="form.category === 2">
      <b>AMEND CHANGES REVIEW (PURCHASE ORDER)</b>
    </h5>
    <h5 v-if="form.category === 4">
      <b>AMEND CHANGES REVIEW (DELIVERY ORDER)</b>
    </h5>
    <h5 v-if="form.category === 3">
      <b>AMEND CHANGES REVIEW (MONTHLY FORECAST)</b>
    </h5>
    <hr />

    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-fullName`">Full Name</label>
          <b-form-input
            v-model="form.name"
            :id="`input-fullName`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-date`">Date</label>
          <b-form-input
            v-model="form.date"
            :id="`input-date`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-comp_name`">Company Name</label>
          <b-form-input
            v-model="form.comp_name"
            :id="`input-comp_name`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-roles`">Roles</label>
          <b-form-input
            v-model="form.role"
            :id="`input-roles`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4" v-if="form.category === 1">
        <b-form-group>
          <label :for="`input-outlet_category`">Outlet Category</label>
          <b-form-input
            v-model="form.outlet_category"
            :id="`input-outlet_category`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4" v-if="form.category === 1">
        <b-form-group>
          <label :for="`input-outlet_name`">Outlet Name</label>
          <b-form-input
            v-model="form.outlet_name"
            :id="`input-outlet_name`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="4" v-if="form.suboutlet_cat">
        <b-form-group>
          <label :for="`input-outlet_category`">Sub Outlet Category</label>
          <b-form-input
            v-model="form.suboutlet_cat"
            :id="`input-outlet_category`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-size`">Product Type</label>
          <b-form-input
            v-model="form.type"
            id="input-horizontal"
            type="text"
            required
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4" v-if="form.category === 1">
        <b-form-group>
          <label :for="`input-role`">Chiller</label>
          <b-form-radio-group
            v-model="form.chiller"
            :options="chiller"
            plain
            disabled
            name="plain-inline"
          ></b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>

    <br />

    <div v-if="status === '1'">
      <div v-if="form.category === 1">
        <h5><b>Stockout</b></h5>
        <hr />
        <TableOldStock
          :grandp="grandPP.toFixed(2)"
          :fields="fieldOld"
          :items="itemsOldStock"
        />
      </div>

      <div v-if="form.category === 2 || form.category === 4">
        <h5 v-if="form.category === 2"><b>Purchase Order</b></h5>
        <h5 v-if="form.category === 4"><b>Delivery Order</b></h5>
        <TablePOChangeOld :fields="others_field.old" :items="itemsOldStock" />
      </div>

      <div v-if="form.category === 3">
        <h5 v-if="form.category"><b>Monthly Forecast</b></h5>
        <b-tabs content-class="mt-3">
          <b-tab title="Week 1" active>
            <TablePOChangeOld
              :fields="others_field.old"
              :items="items_mf_old.data1"
            />
          </b-tab>
          <b-tab title="Week 2">
            <TablePOChangeOld
              :fields="others_field.old"
              :items="items_mf_old.data2"
            />
          </b-tab>
          <b-tab title="Week 3">
            <TablePOChangeOld
              :fields="others_field.old"
              :items="items_mf_old.data3"
            />
          </b-tab>
          <b-tab title="Week 4">
            <TablePOChangeOld
              :fields="others_field.old"
              :items="items_mf_old.data4"
            />
          </b-tab>
          <b-tab title="Week 5">
            <TablePOChangeOld
              :fields="others_field.old"
              :items="items_mf_old.data5"
            />
          </b-tab>
        </b-tabs>
      </div>
      <b-row align="center">
        <b-col>
          <b-button variant="primary" size="sm" @click="onClickBack">
            BACK
          </b-button>
        </b-col>
      </b-row>
    </div>
    <div v-else>
      <div v-if="form.category === 1">
        <h5><b>New Stockout</b></h5>
        <hr />
        <TableNewStock
          :grand="grandP.toFixed(2)"
          :fields="fields"
          :items="items"
        />

        <h5><b>Old Stockout</b></h5>
        <hr />
        <TableOldStock
          :grandp="grandPP.toFixed(2)"
          :fields="fieldOld"
          :items="itemsOldStock"
        />
      </div>

      <div v-if="form.category === 2 || form.category === 4">
        <h5 v-if="form.category === 2"><b>New Purchase Order</b></h5>
        <h5 v-if="form.category === 4"><b>New Delivery Order</b></h5>
        <hr />
        <TablePOChangeNew :fields="others_field.new" :items="items" />

        <h5 v-if="form.category === 2"><b>Old Purchase Order</b></h5>
        <h5 v-if="form.category === 4"><b>Old Delivery Order</b></h5>
        <TablePOChangeOld :fields="others_field.old" :items="itemsOldStock" />
      </div>

      <div v-if="form.category === 3">
        <h5 v-if="form.category"><b>New Monthly Forecast</b></h5>
        <b-tabs content-class="mt-3">
          <b-tab title="Week 1" active>
            <TablePOChangeNew
              :fields="others_field.new"
              :items="items_mf_new.data1"
            />
          </b-tab>
          <b-tab title="Week 2">
            <TablePOChangeNew
              :fields="others_field.new"
              :items="items_mf_new.data2"
            />
          </b-tab>
          <b-tab title="Week 3">
            <TablePOChangeNew
              :fields="others_field.new"
              :items="items_mf_new.data3"
            />
          </b-tab>
          <b-tab title="Week 4">
            <TablePOChangeNew
              :fields="others_field.new"
              :items="items_mf_new.data4"
            />
          </b-tab>
          <b-tab title="Week 5">
            <TablePOChangeNew
              :fields="others_field.new"
              :items="items_mf_new.data5"
            />
          </b-tab>
        </b-tabs>

        <h5 v-if="form.category"><b>Old Monthly Forecast</b></h5>
        <b-tabs content-class="mt-3">
          <b-tab title="Week 1" active>
            <TablePOChangeOld
              :fields="others_field.old"
              :items="items_mf_old.data1"
            />
          </b-tab>
          <b-tab title="Week 2">
            <TablePOChangeOld
              :fields="others_field.old"
              :items="items_mf_old.data2"
            />
          </b-tab>
          <b-tab title="Week 3">
            <TablePOChangeOld
              :fields="others_field.old"
              :items="items_mf_old.data3"
            />
          </b-tab>
          <b-tab title="Week 4">
            <TablePOChangeOld
              :fields="others_field.old"
              :items="items_mf_old.data4"
            />
          </b-tab>
          <b-tab title="Week 5">
            <TablePOChangeOld
              :fields="others_field.old"
              :items="items_mf_old.data5"
            />
          </b-tab>
        </b-tabs>
      </div>

      <b-row align="center">
        <b-col>
          <b-button variant="primary" size="sm" @click="onClickBack">
            BACK</b-button
          >&nbsp;&nbsp;
          <b-button variant="danger" size="sm" @click="onClickReject">
            REJECT</b-button
          >&nbsp;&nbsp;
          <b-button variant="success" size="sm" @click="onClickApprove">
            APPROVE</b-button
          >
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import TableOldStock from "@/table/admin/stockoutChanges/TableOldStock";
import TableNewStock from "@/table/admin/stockoutChanges/TableNewStock";
import TablePOChangeNew from "@/table/user/stockoutChanges/TablePOChangeNew";
import TablePOChangeOld from "@/table/user/stockoutChanges/TablePOChangeOld";

export default {
  data() {
    return {
      items: [],
      grandP: "",
      grandPP: "",
      itemsOldStock: [],
      form: {
        name: "",
        date: "",
        comp_name: "",
        role: "",
        outlet_category: "",
        outlet_name: "",
        type: "",
        chiller: "",
        category: "",
        suboutlet_cat: ""
      },

      // Chiller
      chiller: [
        { value: "1", text: "Yes" },
        { value: "0", text: "No" }
      ],

      items_mf_old: {
        data1: [],
        data2: [],
        data3: [],
        data4: [],
        data5: []
      },

      items_mf_new: {
        data1: [],
        data2: [],
        data3: [],
        data4: [],
        data5: []
      },

      status: "",

      others_field: {
        new: [
          {
            label: "No",
            key: "no",
            sortable: false
          },
          {
            label: "Product Name",
            key: "name",
            sortable: true
          },
          {
            label: "Quantity",
            key: "quantity",
            sortable: true
          }
        ],
        old: [
          {
            label: "No",
            key: "no",
            sortable: false
          },
          {
            label: "Product Name",
            key: "name",
            sortable: true
          },
          {
            label: "Quantity",
            key: "quantity",
            sortable: true
          }
        ]
      },

      fields: [
        {
          label: "No",
          key: "no",
          sortable: false
        },
        {
          label: "Product Name",
          key: "name",
          sortable: true
        },
        {
          label: "Quantity",
          key: "quantity",
          sortable: true
        },
        {
          label: "Price (RM)",
          key: "price",
          sortable: true
        },
        {
          label: "Total Price (RM)",
          key: "totalPrice",
          sortable: true
        }
      ],
      fieldOld: [
        {
          label: "No",
          key: "no",
          sortable: false
        },
        {
          label: "Product Name",
          key: "name",
          sortable: true
        },
        {
          label: "Quantity",
          key: "quantity",
          sortable: true
        },
        {
          label: "Price (RM)",
          key: "price",
          sortable: true
        },
        {
          label: "Total Price (RM)",
          key: "totalPrice",
          sortable: true
        }
      ]
    };
  },
  created() {
    this.status = this.$route.query.status;
    this.showSC();
    this.form.type =
      parseInt(this.$route.query.pro_cat) === 1 ? "UHT" : "Pasteurized";
  },
  methods: {
    onClickBack() {
      this.$router.go(-1);
    },

    onClickReject() {
      this.onClickSubmit(3);
    },

    onClickApprove() {
      this.onClickSubmit(1);
    },

    onClickSubmit(status) {
      this.$store
        .dispatch("updateStatusMF", {
          id: this.$route.query.id,
          category: 5,
          status: status
        })
        .then(res => {
          if (res.data.response.code === 1) {
            this.$router.push({ path: `stockout_changes` });
          }
        });
    },
    showSC() {
      this.$store
        .dispatch("showSC", {
          category: this.$route.query.cat,
          amend_changes_id: this.$route.query.id
        })
        .then(res => {
          let price = 0;
          let price2 = 0;
          if (res.data.response.code === 100) {
            this.form.id = this.$route.query.id;
            this.form.name = res.data.data.userdetails.name;
            this.form.date = res.data.data.date_request;
            this.form.comp_name = res.data.data.userdetails.company;
            this.form.role = res.data.data.userdetails.role_details.desc;
            this.form.outlet_category = res.data.data.outlet_id;
            this.form.outlet_name = res.data.data.outlet_name;
            this.form.chiller = res.data.data.chiller;
            this.form.category = res.data.data.category;

            if (res.data.data.sub_outlet_id) {
              this.form.suboutlet_cat = res.data.data.sub_outlet_id;
            }

            if (res.data.data.category === 3) {
              let week = res.data.data.old_pro_stock;
              week.forEach(item => {
                // Week 1
                if (item.week === 1) {
                  let week1 = [];
                  item.pro_stock.forEach(item2 => {
                    week1.push({
                      isActive: true,
                      pro_stock_id: item2.pro_stock_id,
                      name: item2.product.name,
                      sku: item2.product_id,
                      quantity: item2.quantity,
                      index: item2.index,
                      action: "fas fa-user"
                    });
                  });
                  this.items_mf_old.data1 = week1;
                }

                // Week 2
                if (item.week === 2) {
                  let week2 = [];
                  item.pro_stock.forEach(item2 => {
                    week2.push({
                      isActive: true,
                      pro_stock_id: item2.pro_stock_id,
                      name: item2.product.name,
                      sku: item2.product_id,
                      quantity: item2.quantity,
                      index: item2.index,
                      action: "fas fa-user"
                    });
                  });
                  this.items_mf_old.data2 = week2;
                }

                // Week 3
                if (item.week === 3) {
                  let week3 = [];
                  item.pro_stock.forEach(item2 => {
                    week3.push({
                      isActive: true,
                      pro_stock_id: item2.pro_stock_id,
                      name: item2.product.name,
                      sku: item2.product_id,
                      quantity: item2.quantity,
                      index: item2.index,
                      action: "fas fa-user"
                    });
                  });
                  this.items_mf_old.data3 = week3;
                }

                // Week 4
                if (item.week === 4) {
                  let week4 = [];
                  item.pro_stock.forEach(item2 => {
                    week4.push({
                      isActive: true,
                      pro_stock_id: item2.pro_stock_id,
                      name: item2.product.name,
                      sku: item2.product_id,
                      quantity: item2.quantity,
                      index: item2.index,
                      action: "fas fa-user"
                    });
                  });
                  this.items_mf_old.data4 = week4;
                }

                // Week 5
                if (item.week === 5) {
                  let week5 = [];
                  item.pro_stock.forEach(item2 => {
                    week5.push({
                      isActive: true,
                      pro_stock_id: item2.pro_stock_id,
                      name: item2.product.name,
                      sku: item2.product_id,
                      quantity: item2.quantity,
                      index: item2.index,
                      action: "fas fa-user"
                    });
                  });
                  this.items_mf_old.data5 = week5;
                }
              });

              let week_new = res.data.data.fc_week;
              week_new.forEach(item => {
                // Week 1
                if (item.week === 1) {
                  let week1 = [];
                  item.pro_stock.forEach(item2 => {
                    week1.push({
                      isActive: true,
                      pro_stock_id: item2.pro_stock_id,
                      name: item2.product.name,
                      sku: item2.product_id,
                      quantity: item2.quantity,
                      index: item2.index,
                      action: "fas fa-user"
                    });
                  });
                  this.items_mf_new.data1 = week1;
                }

                // Week 2
                if (item.week === 2) {
                  let week2 = [];
                  item.pro_stock.forEach(item2 => {
                    week2.push({
                      isActive: true,
                      pro_stock_id: item2.pro_stock_id,
                      name: item2.product.name,
                      sku: item2.product_id,
                      quantity: item2.quantity,
                      index: item2.index,
                      action: "fas fa-user"
                    });
                  });
                  this.items_mf_new.data2 = week2;
                }

                // Week 3
                if (item.week === 3) {
                  let week3 = [];
                  item.pro_stock.forEach(item2 => {
                    week3.push({
                      isActive: true,
                      pro_stock_id: item2.pro_stock_id,
                      name: item2.product.name,
                      sku: item2.product_id,
                      quantity: item2.quantity,
                      index: item2.index,
                      action: "fas fa-user"
                    });
                  });
                  this.items_mf_new.data3 = week3;
                }

                // Week 4
                if (item.week === 4) {
                  let week4 = [];
                  item.pro_stock.forEach(item2 => {
                    week4.push({
                      isActive: true,
                      pro_stock_id: item2.pro_stock_id,
                      name: item2.product.name,
                      sku: item2.product_id,
                      quantity: item2.quantity,
                      index: item2.index,
                      action: "fas fa-user"
                    });
                  });
                  this.items_mf_new.data4 = week4;
                }

                // Week 5
                if (item.week === 5) {
                  let week5 = [];
                  item.pro_stock.forEach(item2 => {
                    week5.push({
                      isActive: true,
                      pro_stock_id: item2.pro_stock_id,
                      name: item2.product.name,
                      sku: item2.product_id,
                      quantity: item2.quantity,
                      index: item2.index,
                      action: "fas fa-user"
                    });
                  });
                  this.items_mf_new.data5 = week5;
                }
              });
            } else {
              res.data.data.pro_stock.forEach(element => {
                let name = "";
                let defPrice = parseFloat(element.total_price_pu);
                price += defPrice;
                if (element.product !== null) {
                  name = element.product.name;
                }
                this.items.push({
                  name: name,
                  sku: element.product_id,
                  quantity: element.quantity,
                  price: element.price,
                  totalPrice: element.total_price_pu
                });
              });
              this.grandP = price;

              res.data.data.old_pro_stock.forEach(element2 => {
                let name = "";
                let defPricee = parseFloat(element2.total_price_pu);
                price2 += defPricee;
                if (element2.product !== null) {
                  name = element2.product.name;
                }
                this.itemsOldStock.push({
                  name: name,
                  sku: element2.product_id,
                  quantity: element2.quantity,
                  price: element2.price,
                  totalPrice: element2.total_price_pu
                });
              });
              this.grandPP = price2;
            }
          }
        });
    }
  },
  components: {
    TableOldStock,
    TableNewStock,
    TablePOChangeNew,
    TablePOChangeOld
  }
};
</script>
<style lang="css" scoped></style>
